import builder, { Builder } from "@builder.io/react";
import Button, { buttonRegistration } from "./custom-components/Button/Button";
import Text, { textRegistration } from "./custom-components/Text/Text";
import colorTokens from "../../assets/css/styles/colorTokens";
import spacesTokens from "../../assets/css/styles/spaceTokens";
import fontTokens from "../../assets/css/styles/fontTokens";
import StaticMap, {
  staticMapRegistration,
} from "./custom-components/StaticMap/StaticMap";
import DynamicMap, {
  dynamicMapRegistration,
} from "./custom-components/DynamicMap/DynamicMap";
import Heading, {
  headingRegistration,
} from "./custom-components/heading/Heading";
import Lightbox, {
  lightBoxRegistration,
} from "./custom-components/Lightbox/Lightbox";
import ManufacturerProductRecommender, {
  manufacturerProductRecommenderBoxRegistration,
} from "./custom-components/manufacturerProductRecommender/manufacturerProductRecommender";
import FloatingActionButton, {
  floatingActionButtonRegistration,
} from "./custom-components/Button/FloatingActionButton";
import GeneralButton, {
  generalButtonRegistration,
} from "./custom-components/Button/GeneralButton";
import SelectButton, {
  selectButtonRegistration,
} from "./custom-components/Button/SelectButton";
import TextButton, {
  textButtonRegistration,
} from "./custom-components/Button/TextButton";
import PromoBanner, { promoBannerRegistration } from "./custom-components/PromoBanner/PromoBanner";
import Icon, { iconRegistration } from "./custom-components/Icon/Icon";

builder.init(process.env.REACT_APP_BUILDER_KEY!);

Builder.registerComponent(Button, buttonRegistration);

Builder.registerComponent(Text, textRegistration);

Builder.registerComponent(StaticMap, staticMapRegistration);

Builder.registerComponent(DynamicMap, dynamicMapRegistration);

Builder.registerComponent(Heading, headingRegistration);

Builder.registerComponent((props: any) => {
  return <Lightbox {...props} />;
}, lightBoxRegistration);

Builder.registerComponent((props: any) => {
  return <PromoBanner {...props} />;
}, promoBannerRegistration);

Builder.registerComponent(
  ManufacturerProductRecommender,
  manufacturerProductRecommenderBoxRegistration
);

Builder.registerComponent(
  FloatingActionButton,
  floatingActionButtonRegistration
);

Builder.registerComponent(GeneralButton, generalButtonRegistration);

Builder.registerComponent(SelectButton, selectButtonRegistration);

Builder.registerComponent(TextButton, textButtonRegistration);

Builder.registerComponent(Icon, iconRegistration);

Builder.register("insertMenu", {
  name: "Buttons",
  items: [
    { name: "General Button" },
    { name: "Floating Action Button" },
    { name: "Select Button" },
    { name: "Text Button" },
  ],
});

Builder.register("editor.settings", {
  designTokens: {
    colors: colorTokens,
    spacing: spacesTokens,
    fontFamily: fontTokens,
  },
  // Enable strict mode to enforce these tokens
  styleStrictMode: false,
});
